export enum CompetitionRegType {
    fixed = 1,
    rotating = 2,
    advisor = 3,
    activator = 4,
    merchant = 5
}
